import {useEffect, useState} from "react";
import {RiCheckLine, RiCloseFill} from "react-icons/ri";
import {accountInfo} from "../../constants/constants";
import neverLandGameDataExpansion from "../../utils/NeverLandGameDataExpansion";

const BasketResultCard = ({filteredOdds}) => {
  const [updateDate, setUpdateDate] = useState(new Date());

  const refreshList = () => {
    setUpdateDate(new Date());
  };

  useEffect(() => {
    neverLandGameDataExpansion.addOnChangedHandler(refreshList);
    return () => {
      neverLandGameDataExpansion.removeOnChangedHandler(refreshList);
    };

  }, []);

  const basketTicketList = neverLandGameDataExpansion.getBasketItems();

  // filteredOdds 활용해서 선택한 배당만 필터링
  const ticketList = filteredOdds.length > 0
    ? basketTicketList.filter(ticket => {
      const rateInt = Math.floor(ticket.finalResult);
      return filteredOdds.includes(rateInt);
    }) : []; // 빈 배열이면 아무것도 안 띄우기


  const sortTicketGames = (ticket) => {
    if (!ticket.gameCombination) return ticket;

    ticket.gameCombination.sort((game1, game2) => {
      // gameNo에서 * 제거하고 숫자로 변환
      const num1 = parseInt(game1.gameNo.replace('*', ''));
      const num2 = parseInt(game2.gameNo.replace('*', ''));

      return num1 - num2;
    });

    return ticket;
  }

  return (
    <div className="space-y-6 h-full flex flex-col">
      {/* 상단 전체 담기 버튼과 총 조합 수 */}
      <div className="flex items-center flex-shrink-0">
        <button onClick={()=>neverLandGameDataExpansion.selectItemAll()}
                className="bg-indigo-200 px-3 py-2 font-medium rounded-md shadow-md mr-5"
        >
          전체 선택
        </button>

        <span
          className={`text-lg font-semibold ${accountInfo.isDarkMode() ? 'text-white' : 'text-black'}`}
        >
          총 {ticketList.length}개의 조합
        </span>
      </div>

      <div className="overflow-y-auto flex-1 grid grid-cols-1 gap-4 md:grid-cols-2 pl-1 pr-2 pt-1">
        {ticketList?.map((ticket) => {
          const isSaved = neverLandGameDataExpansion.isSelected(ticket.id);

          return (
            <div
              key={ticket.id}
              onClick={() => neverLandGameDataExpansion.toggleSelectItem(ticket.id)}
              className={`cursor-pointer transition-all duration-300 rounded-lg border border-gray-300 shadow-md ${
                isSaved
                  ? "border-yellow-500 bg-amber-100 shadow-lg ring-4 ring-amber-500"
                  : "bg-white"
              }`}
            >
              {/* 상단 버튼 영역 */}
              <div className="flex items-center justify-between p-3">
                {/*카드 삭제 버튼*/}
                <button
                  onClick={() => neverLandGameDataExpansion.removeItemFromList(ticket.id)}
                  className="p-1 rounded-md shadow-md border border-gray-400 bg-white"
                >
                  <RiCloseFill className="h-5 w-5 text-gray-500"/>
                </button>

                {/*카드 총 배당*/}
                <span
                  className={`rounded-full flex min-w-20 py-1.5 items-center justify-center font-semibold backdrop-blur-xl shadow-2xl ${
                    isSaved
                      ? "bg-gradient-to-br from-orange-500/100 via-orange-600/100 to-orange-700/90 text-white px-3 border border-white/20 shadow-orange-500/50"
                      : "bg-gradient-to-br from-blue-200/60 via-blue-300/60 to-blue-400/60 text-gray-900 px-4 border border-blue-100/30 shadow-blue-200/50"
                  }`}
                >
                  {ticket.finalResult} 배
                  {isSaved && <RiCheckLine className="ml-2 h-5 w-5 text-white drop-shadow-lg" strokeWidth={3}/>}
                </span>
              </div>

              {/* <-- 경기 테이블 영역 --> */}
              <div className="px-2 pb-2 overflow-x-hidden">
                <table
                  className="w-full rounded-lg border border-gray-500 border-separate border-spacing-0 bg-white shadow-md">
                  <thead>
                  <tr className="bg-gray-900 text-white text-xs font-semibold whitespace-nowrap">
                    <th className="px-2 py-3 text-center rounded-tl-lg">경기</th>
                    <th className="px-2 py-3 text-center">홈팀</th>
                    <th>:</th>
                    <th className="px-2 py-3 text-center">원정팀</th>
                    <th className="px-1 py-3 text-center">예상</th>
                    <th className="px-1 py-3 text-center rounded-tr-lg">배당률</th>
                  </tr>
                  </thead>

                  <tbody>
                  {sortTicketGames(ticket).gameCombination.map((game) => (
                    <tr key={game.allotId} className="text-xs">
                      <td className="px-1 py-2 w-11 text-right font-semibold flex flex-row justify-end">
                        <p>
                          {game.type === "UNDER_OVER" && "U"}
                          {game.type === "SUM" && "S"}
                          {game.type === "HANDICAP" && "H"}
                        </p>
                        <p>
                          {game.gameNo}
                        </p>
                      </td>
                      <td className="px-1 py-2 font-semibold whitespace-nowrap">
                        {game.homeTeam} {game.extra !== "0.0" ? game.extra : ""}
                      </td>
                      <td>:</td>
                      <td className="px-2 py-2 font-semibold whitespace-nowrap">{game.awayTeam}</td>
                      <td
                        className="px-1 py-2 text-center font-semibold whitespace-nowrap">{neverLandGameDataExpansion.getPredictionText(game.type, game.choice, game.allotTypeCategory)}</td>
                      <td className="px-1 py-2 text-center font-semibold">{game.value}</td>
                    </tr>
                  ))}
                  </tbody>
                </table>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default BasketResultCard;